import { print, print2 } from "@/components/PrintTemplate/index.js";

const size = {
  1: {
    width: 40,
    height: 80
  },
  2: {
    width: 50,
    height: 30
  }
}
let toPrintZozotown = async function (zozotownConfig, arr, tagExtendParams) {
  const logoConfig = zozotownConfig.templateJson.filter(v => v.name_zh == 'LOGO')[0]
  const imgSize = logoConfig ? await getImageSize(tagExtendParams.tagLogo) : {}
  let json = {
    panels: [{
      height: size[zozotownConfig.size].height,
      width: size[zozotownConfig.size].width,
      paperNumberDisabled: true,
      printElements: zozotownConfig.templateJson.filter(v => v.name_zh != 'LOGO').map(v => {
        return {
          options: {
            ...v,
            "fontWeight": "bold"
          },
          printElementType: {
            title: '文本',
            type: 'text'
          }
        }
      })
    }]
  }
  if (logoConfig) {
    json.panels[0].printElements.push({
      options: {
        ...logoConfig,
        ...imgSize,
        src: tagExtendParams.tagLogo
      },
      printElementType: {
        title: '图片',
        type: 'image'
      }
    })
  }
  print2(json, translateArr(arr));

  function translateArr(arr) {
    return arr.map(v => {
      return {
        ...v,
        // price: v.price.toLocaleString()
        price: /\./.test(String(v.price)) ? String(v.price).replace(/(\d{1,3})(?=(\d{3})+\.)/g, "$1,") : String(v.price).replace(/(\d{1,3})(?=(\d{3})+\b)/g, "$1,")
      }
    })
  }

  function getImageSize(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        // callback({ width: img.width, height: img.height });
        console.log(img.width, img.height)
        if ((img.width / logoConfig.width) > (img.height / logoConfig.height)) {
          console.log(1)
          let multiple = img.width / logoConfig.width
          resolve({
            width: img.width / multiple,
            height: img.height / multiple,
            top: (logoConfig.top || 0) + (logoConfig.height - img.height / multiple) / 2
          })
        } else {
          console.log(2)
          let multiple = img.height / logoConfig.height
          resolve({
            width: img.width / multiple,
            height: img.height / multiple,
            left: (logoConfig.left || 0) + (logoConfig.width - img.width / multiple) / 2
          })
        }
      };
      img.onerror = function () {
        resolve({
          width: logoConfig.width,
          height: logoConfig.height
        })
      };
      img.src = url;
    })
  }
}

export {
  toPrintZozotown
}